import StockCountCreateCategoriesModal from './modals/StockCountCreateCategoriesModal';
import StockCountCreateItemsModal from './modals/StockCountCreateItemsModal';
import StockCountCreateBulkModal from './modals/StockCountCreateBulkModal';
import StockCountCreateDeleteCategoryModal from './modals/StockCountCreateDeleteCategoryModal';
import StockCountCreateDeleteItemsModal from './modals/StockCountCreateDeleteItemsModal';
import MessagesSnackbar from '../../../components/shared/MessagesSnackbar';
import { useContext } from 'react';
import { StockCountCreateContext, StockCountCreateValues } from '../contexts/StockCountCreateContext';
import LeavePageWithoutSaveModal from '../../../components/shared/dialogs/LeavePageWithoutSaveModal';
import StockCountCreateTypesModal from './modals/StockCountCreateTypesModal';
import StockCountCreateDeleteProductTypeModal from './modals/StockCountCreateDeleteProductTypeModal';
import StockCountCreateCountZonesModal from './modals/StockCountCreateCountZonesModal';
import StockCountCreateDeleteCountZonesModal from './modals/StockCountCreateDeleteCountZonesModal';
import StockCountCreateViewItemsOfCountZone from './modals/StockCountCreateViewItemsOfCountZones';
import StockCountExistingCountModal from './modals/StockCountExistingCountModal';

const StockCountCreatePopUps = () => {
  const { closeSnackBar,
    isSnackBarOpen,
    snackBarSeverity,
    snackbarMessage,
    snackBarDuration,
    blocker,
    isProductTypeModalOpen,
    isEndOfMonthCountModalOpen,
    handleLeavePageModalClose,
    handleLeavePageModalConfirm } = useContext(StockCountCreateContext) as StockCountCreateValues;

  return (
    <>
      <StockCountCreateCountZonesModal />
      <StockCountCreateCategoriesModal />
      {isProductTypeModalOpen && <StockCountCreateTypesModal />}
      {isEndOfMonthCountModalOpen && <StockCountExistingCountModal/>}
      <StockCountCreateItemsModal />
      <StockCountCreateBulkModal />
      <StockCountCreateDeleteCountZonesModal />
      <StockCountCreateDeleteCategoryModal />
      <StockCountCreateDeleteProductTypeModal />
      <StockCountCreateDeleteItemsModal />
      <StockCountCreateViewItemsOfCountZone/>
      <LeavePageWithoutSaveModal open={blocker.state === 'blocked'}
        onConfirm={handleLeavePageModalConfirm}
        onClose={handleLeavePageModalClose}
        onConfirmUrl='/store/orders-history' />
      <MessagesSnackbar onClose={closeSnackBar}
        open={isSnackBarOpen}
        severity={snackBarSeverity}
        message={snackbarMessage}
        duration={snackBarDuration} />
    </>
  );
};

export default StockCountCreatePopUps;